import styled from 'styled-components'
import globals from '../globals'

const FAQ = styled.dl`
  width:100%;
  max-width:720px;
  display:block;
  margin:0 auto;
  text-align: center;

  button {
    background:none;
    border:none;
    padding:0;
    margin:0;
    width:100%;
    display:block;
    transition: color .1s ease;
    cursor: pointer;
    color: ${globals.colors.darkblue};

    &:active, &:focus {
      outline:none;
      color: ${globals.colors.lightblue};
    }
  }

  dt {
    padding:20px 0;

    h4 {
      margin:0;
      padding:0;
    }
  }

  dd {
    line-height:1.6;
  }
`

export default FAQ;